<input nbInput [value]="timeRangeLabel" [nbPopover]="templateRef" [nbPopoverPlacement]="'bottom'" nbPopoverTrigger="noop" (click)="openPopover()"/>

<ng-template #templateRef>
  <div class="time-picker-popover">
      <nb-card-body>
        <nb-icon icon="close-outline" pack="eva" (click)="closePopover()"></nb-icon>

        <!-- Absolute Time Range -->
        <div class="absolute-time-range">
          <div class="section-title">{{ 'data.TIME_PICKER.ABSOLUTE_TITLE' | translate }}</div>

          <div class="field-group">
            <label>{{ 'data.TIME_PICKER.FROM' | translate }}</label>
            <input nbInput [(ngModel)]="dateFrom" placeholder="{{'data.TIME_PICKER.SELECT_DATE' | translate}}" [nbDatepicker]="fromPicker">
            <nb-date-timepicker [max]="dateTo || now" #fromPicker>
            </nb-date-timepicker>
          </div>

          <div class="field-group">
            <label>{{ 'data.TIME_PICKER.TO' | translate }}</label>
            <input nbInput [(ngModel)]="dateTo" [placeholder]="now" [nbDatepicker]="toPicker">
            <nb-date-timepicker [min]="dateFrom" [max]="now" #toPicker>
            </nb-date-timepicker>
          </div>

          <button nbButton class="apply-button" status="primary" [disabled]="!dateFrom || !dateTo || dateFrom > dateTo"
            (click)="selectAbsoluteRange()">{{ 'data.TIME_PICKER.APPLY' | translate }}</button>
        </div>

        <!-- Relative Time Range -->
        <div class="relative-time-range">
          <div class="section-title">{{ 'data.TIME_PICKER.RELATIVE_TITLE' | translate }}</div>

          <div class="relative-buttons">
            <button nbButton *ngFor="let range of relativeRanges"
              [class.active]="range?.value === selectedRelativeRange?.value" (click)="selectRelativeRange(range)">
              {{ range.label }}
            </button>
          </div>
        </div>
      </nb-card-body>
  </div>
</ng-template>
